"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const apollo_boost_1 = require("apollo-boost");
const react_csv_1 = require("react-csv");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const moment_1 = __importDefault(require("moment"));
const AssertionInfosView_1 = require("../../../assertion/AssertionInfosView");
function DownloadingView(props) {
    const { loading: isLoading, error, data } = react_hooks_1.useQuery(apollo_boost_1.gql `
  query {
    getAssertionInfos {
      id
      sn
      status
      warehouse {
        name
      }
      startDate
      submitDate
      assertedCost
      assertedQty
      projectedCost
      projectedQty
    }
  }
  `);
    if (error)
        return react_1.default.createElement(react_1.default.Fragment, null, "error");
    if (isLoading || data === undefined)
        return react_1.default.createElement(react_1.default.Fragment, null, "\u6B63\u5728\u6E96\u5099\u8981\u4E0B\u8F09\u7684\u8CC7\u6599");
    const header = [
        '盤點單號',
        '門市',
        '狀態',
        '開始時間',
        '送出時間',
        '已點數量',
    ];
    if (props.canDisplayCost) {
        header.push('已點金額');
    }
    header.push('盤差數量');
    if (props.canDisplayCost) {
        header.push('盤差金額');
    }
    const output = [header];
    data.getAssertionInfos.forEach((e) => {
        const row = [
            e.sn,
            e.warehouse.name,
            AssertionInfosView_1.AssertInfoStatusDesc[e.status],
            e.startDate,
            e.submitDate,
            e.assertedQty,
        ];
        if (props.canDisplayCost) {
            row.push(e.assertedCost);
        }
        row.push(e.assertedQty - e.projectedQty);
        if (props.canDisplayCost) {
            row.push(e.assertedCost - e.projectedCost);
        }
        output.push(row);
    });
    const filename = `盤點單列表-${moment_1.default().format('YYYYMMDDHHmm')}-.csv`;
    return (react_1.default.createElement(react_csv_1.CSVLink, { data: output, filename: filename }, "\u4E0B\u8F09\u76E4\u9EDE\u55AE\u5217\u8868 (csv)"));
}
function AssertInfosDownloaderView(props) {
    const [isPreparing, setToPrepare] = react_1.useState(false);
    const actions = [
        {
            text: '下載',
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                setToPrepare(true);
            }),
            props: {
                variant: 'outlined',
            },
        },
    ];
    const view = (() => {
        if (!isPreparing) {
            return (react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }));
        }
        return react_1.default.createElement(DownloadingView, { canDisplayCost: props.canDisplayCost });
    })();
    return (react_1.default.createElement("div", { style: {
            margin: '0px 30px',
            display: 'inline-block',
        } }, view));
}
exports.default = AssertInfosDownloaderView;
